import { motion } from "framer-motion";

export const CtaSection = () => {
  return (
    <section className="relative py-32 lg:py-[200px] overflow-hidden bg-[#08080A]">
      {/* Background Gradient & Noise */}
      <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none">
        <div className="w-[800px] h-[600px] bg-gradient-to-tr from-[#7C3AED] via-[#6366F1] to-[#FB7185] rounded-full blur-[120px] opacity-15" />
      </div>
      <div
        className="absolute inset-0 z-0 opacity-[0.08] pointer-events-none mix-blend-overlay"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
        }}
      />

      <div className="container relative z-20 mx-auto px-6 max-w-[800px] text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="text-[36px] md:text-[52px] lg:text-[64px] font-medium text-[#FAFAFA] tracking-[-0.03em] leading-[1.05] mb-8"
        >
          El primer trabajo que recuperes paga el sistema.
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.6, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="text-[#A1A1AA] text-[18px] md:text-[20px] leading-[1.6] mb-12 max-w-[600px] mx-auto"
        >
          Te mostramos cuentas reales funcionando y te decimos si CreceLocal
          sirve para tu negocio.
        </motion.p>

        <div className="flex flex-col items-center justify-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.6, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
            className="flex flex-col items-center justify-center gap-6 mb-8"
          >
            <button
              onClick={() => {
                import("@/lib/analytics").then(({ trackCTA }) =>
                  trackCTA("Cierre - Agendar llamada"),
                );
                window.location.href = "/demo";
              }}
              className="bg-[#7C3AED] text-[#FAFAFA] hover:bg-[#7C3AED]/90 hover:-translate-y-[2px] transition-all hover:shadow-[0_12px_32px_rgba(124,58,237,0.25)] font-medium rounded-[12px] px-10 py-[18px] text-[18px] inline-flex items-center justify-center gap-2"
            >
              Agendar una llamada
            </button>
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="text-[#71717A] font-mono text-[12px] tracking-[0.08em] uppercase"
          >
            15 minutos · Sin compromiso
          </motion.p>
        </div>
      </div>
    </section>
  );
};
